import { axiosIns } from "../utils";

export const fetchFonctions = async () => {
  const response = await axiosIns.get("/fonctions/");
  return response && response.data ? response.data : response;
};

export const createFonctionApi = async (payload) => {
  const response = await axiosIns.post("/fonctions/", payload);
  return response && response.data ? response.data : response;
};

export const updateFonctionApi = async (id, payload) => {
  const response = await axiosIns.patch(`/fonctions/${id}/`, payload);
  return response && response.data ? response.data : response;
};

export const deleteFonctionApi = async (id) => {
  const response = await axiosIns.delete(`/fonctions/${id}/`);
  return response && response.data ? response.data : response;
};
